import React from 'react';
import BalanceGridRow from '../types';

type Props = {
  data: BalanceGridRow;
};

const NetSettledRenderer = ({ data }: Props) => {
  return <input type="checkbox" checked={data?.netSettled} disabled />;
};

export default NetSettledRenderer;
